export default __webpack_public_path__ + "static/media/email.e17cf873.svg";